export const ORDER_COLUMNS = [
  {
    label: "اسم المُنتج",
    dataIndex: "name",
    width: "40%",
    align: "start",
    paddingStart: "3rem",
  },
  {
    label: "السعر",
    dataIndex: "price",
    align: "center",
  },
  {
    label: "الكمية",
    dataIndex: "quantity",
    align: "center",
  },
  {
    label: "الإجمالي",
    dataIndex: "total",
    align: "center",
  },
];

export const BUNDLE_SKUS_COLUMNS = [
  {
    label: "اسم المُنتج",
    dataIndex: "name",
    width: "80%",
    align: "start",
    paddingStart: "12rem",
  },

  {
    label: "الكمية",
    dataIndex: "quantity",
    align: "center",
  },
];

export const CART_ITEMS_COLUMNS = [
  {
    label: "اسم المُنتج",
    dataIndex: "name",
    width: "40%",
    align: "start",
    paddingStart: "3rem",
  },
  {
    label: "السعر",
    dataIndex: "price",
    align: "center",
  },
  {
    label: "الكمية",
    dataIndex: "quantity",
    align: "center",
  },
  {
    label: "الإجمالي",
    dataIndex: "total",
    align: "center",
  },
  {
    label: "",
    dataIndex: "delete",
    align: "center",
  },
];

export const ORDER_SUMMARY_COLUMNS = [
  {
    label: "اسم المُنتج",
    dataIndex: "name",
    width: "40%",
    align: "start",
    paddingStart: "3rem",
  },
  {
    label: "السعر",
    dataIndex: "price",
    align: "center",
  },
  {
    label: "الكمية",
    dataIndex: "quantity",
    align: "center",
  },
  {
    label: "الإجمالي",
    dataIndex: "total",
    align: "center",
  },
];

export const ORDER_ITEMS_PRICES_COLUMNS = [
  {
    label: "اسم المُنتج",
    dataIndex: "name",
    width: "35%",
    align: "start",
    verticalAlign: "top",
    paddingStart: "3rem",
  },
  {
    label: "الأسعار المتاحة",
    dataIndex: "prices",
  },
];
